export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-3xl p-8 md:p-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">移动端阅读体验</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              51漫画在线网页版已完美适配手机浏览器，无需下载安装即可享受流畅的下拉式阅读体验。随时随地打开浏览器，搜索51漫画在线观看，海量漫画即刻畅读。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-full border border-background-300 cursor-pointer hover:border-primary-300 transition-colors">
                <i className="ri-android-line text-foreground-700 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">网页版直达</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-full border border-background-300 cursor-pointer hover:border-primary-300 transition-colors">
                <i className="ri-apple-line text-foreground-700 text-lg"></i>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">iOS 网页版</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-56 md:w-64 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20colorful%20manga%20reading%20interface%20on%20screen%20with%20Japanese%20manga%20style%20artwork%2C%20clean%20UI%20design%20with%20warm%20peach%20background%2C%20scrolling%20manga%20panels%20visible%2C%20modern%20phone%20frame%2C%20minimal%20simple%20setting%2C%20digital%20product%20photography&width=512&height=910&seq=app-mobile-mockup&orientation=portrait"
                alt="51漫画移动端阅读界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}